<template>
  <div class="surface-design-texture">
    <TopPanel
      @search="surfaceDesignTexturesStore.searchByItems"
      @sort-order="surfaceDesignTexturesStore.setSortOrderItems"
      @sort-option="surfaceDesignTexturesStore.sortItems"
      :sort-options="sortOptions"
      :title="surfaceDesignTexturesStore.selectedCollectionName"
      :needExtra="false"
      :create="false"
      backLink="/user/surface-design-textures"
      backText="Back to all textures"
      @rename="editModal"
      @del="delModal"
      @edit="$router.push('/user/surface-design-textures-edit')"
    >
    </TopPanel>
    <EmptyGrid
      v-if="surfaceDesignTexturesStore.itemsCount === 0"
      @create-new="createNewItem"
      :buttonPlusIcon="false"
      :buttonEditIcon="true"
    >
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
          <path stroke="#09373D" stroke-linecap="round" stroke-width="1.5" d="M17.5332 4.69928 4.69987 17.5326M17.416 10.0834l-7.3333 7.3334m-5.49872-5.5001 7.33332-7.33335M17.416 15.5833l-1.8333 1.8333M4.58398 6.41681l1.83334-1.83333"/>
        </svg>
      </template>
      <template v-slot:title>This collection is empty</template>
      <template v-slot:text>Click “Edit” button to add textures</template>
      <template v-slot:button-text>Edit collection</template>
    </EmptyGrid>
    <div v-else class="items">
      <div  class="item" v-for="item in surfaceDesignTexturesStore.items" :key="item.id">
        <div class="img-container"><img :src="`https://cdn.patternfast.com${item.url}`"/></div>
        <p v-if="item.name">{{item.name}}</p>
      </div>
    </div>
    <PaginationComponent
      :limit="surfaceDesignTexturesStore.itemsParams.limit"
      :offset="surfaceDesignTexturesStore.itemsParams.offset"
      :total="surfaceDesignTexturesStore.itemsCount"
      @setOffset="setOffset"
    />
    <ModalComponent @close="surfaceDesignTexturesStore.renameModalToggle()" :show="surfaceDesignTexturesStore.renameModal" >
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 32 32">
          <path d="M21.334 5.14a2.08 2.08 0 0 0-1.475.606l-4.39 4.39L4.803 20.804a.75.75 0 0 0-.219.531v5.332a.75.75 0 0 0 .75.75h5.332a.75.75 0 0 0 .531-.219L21.863 16.53l4.39-4.388a2.096 2.096 0 0 0 0-2.948l-3.446-3.447a2.076 2.076 0 0 0-1.473-.605zm0 1.49c.148 0 .295.06.412.177l3.447 3.447a.574.574 0 0 1 0 .826l-3.859 3.86-4.271-4.272 3.859-3.861a.581.581 0 0 1 .412-.176zM16 11.73 20.273 16l-9.918 9.916H6.084v-4.271L16 11.729z"/>
        </svg>
      </template>
      <template v-slot:title>Rename collection</template>
      <template v-slot:extra>
        <label class="edit-collection-field">
          <span>Collection Name</span>
          <input type="text" placeholder="" v-model="surfaceDesignTexturesStore.collectionName">
        </label>
      </template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignTexturesStore.renameModalToggle()">Cancel</ButtonSecondary>
        <ButtonPrimary class="small" :disabled="surfaceDesignTexturesStore.collectionName?.length === 0"
          @click.native="updateCollection">
          Rename
        </ButtonPrimary>
      </template>
    </ModalComponent>
    <ModalComponent @close="surfaceDesignTexturesStore.delCollectionModalToggle()" type="error"
      :show="surfaceDesignTexturesStore.delCollectionModal">
      <template v-slot:title>Delete collection</template>
      <template v-slot:description>Are you sure? You will lose the textures that are in it</template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignTexturesStore.delCollectionModalToggle()">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary class="small" @click.native="deleteCollection">
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 21 20">
              <path d="M8 1.75c-.866 0-1.584.718-1.584 1.584v.916H3.834a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.916v10.916c0 .866.718 1.584 1.584 1.584h8.332c.866 0 1.584-.718 1.584-1.584V5.75h.916a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-2.582v-.916c0-.866-.718-1.584-1.584-1.584H8zm0 1.5h5c.055 0 .084.03.084.084v.916H7.916v-.916c0-.055.03-.084.084-.084zm-1.75 2.5h8.5v10.916c0 .055-.03.084-.084.084H6.334c-.055 0-.084-.03-.084-.084V5.75z" color="#000" style="-inkscape-stroke:none"/>
            </svg>
          </template>
          Delete
        </ButtonPrimary>
      </template>
    </ModalComponent>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useSurfaceDesignTexturesStore } from '@/store/pinia/surfaceDesignTextures'
import TopPanel from '@/components/SurfaceDesign/TopPanel.vue'
import EmptyGrid from '@/components/Atoms/EmptyGrid.vue'
import ModalComponent from '@/components/Atoms/ModalComponent.vue'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import PaginationComponent from '@/components/Atoms/PaginationComponentLimit.vue'
export default {
  name: 'surfaceDesignTexture',
  data: () => ({
    sortOptions: [
      { name: 'Sort by', value: '' },
      { name: 'Name', value: 'name' },
      { name: 'Last edited', value: 'updatedAt' },
    ],
  }),
  components: {
    TopPanel,
    EmptyGrid,
    ModalComponent,
    ButtonPrimary,
    ButtonSecondary,
    PaginationComponent,
  },
  computed: {
    ...mapStores(useSurfaceDesignTexturesStore),
  },
  methods: {
    async setOffset (offset) {
      this.surfaceDesignPrintPlacementsStore.itemsParams.offset = offset
      const id = this.$route.params.id || this.surfaceDesignTexturesStore.selectedCollectionId
      await this.surfaceDesignTexturesStore.getItems(id)
    },
    createNewItem () {
      this.$router.push('/user/surface-design-textures-edit/')
    },
    deleteCollection () {
      this.surfaceDesignTexturesStore.deleteCollection()
      this.$router.push('/user/surface-design-textures/')
    },
    delModal () {
      this.surfaceDesignTexturesStore.delCollectionModalToggle()
      this.surfaceDesignTexturesStore.collectionId = this.surfaceDesignTexturesStore.selectedCollectionId
    },
    editModal () {
      this.surfaceDesignTexturesStore.renameModalToggle()
      this.surfaceDesignTexturesStore.collectionId = this.surfaceDesignTexturesStore.selectedCollectionId
      this.surfaceDesignTexturesStore.collectionName = this.surfaceDesignTexturesStore.selectedCollectionName
    },
    updateCollection () {
      this.surfaceDesignTexturesStore.selectedCollectionName = this.surfaceDesignTexturesStore.collectionName
      this.surfaceDesignTexturesStore.updateCollection()
    },
  },
  async beforeMount () {
    const id = this.$route.params.id || this.surfaceDesignTexturesStore.selectedCollectionId
    await Promise.all([
      this.surfaceDesignTexturesStore.getItems(id),
      this.surfaceDesignTexturesStore.getCollection(id),
    ])
  },
}
</script>

<style lang="scss">
.surface-design-texture {
  padding: 0 16px 40px 40px;
  .items {
    display: flex;
    gap: 40px;
    margin-top: 42px;
    text-align: center;
    flex-wrap: wrap;
    p {
      margin: 8px 0 0;
      font-size: 14px;
      color: var(--Text-Text_Primary);
    }
    .img-container {
      width: 95px;
      height: 95px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }
    }
  }
}
@media (max-width: 480px) {
  .surface-design-texture {
    padding: 0;
    .buttons-group {
      max-width: 100%;
    }
  }
}
</style>
